// import React, { useState, useCallback } from 'react';
// import { Modal, Box, Stepper, Step, StepLabel, Button, IconButton, StepConnector, Snackbar, Alert, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
// import { styled } from '@mui/system';
// import StepOne from './Steps/StepOne';
// import StepTwo from './Steps/StepTwo';
// import StepThree from './Steps/StepThree';
// import ViewProject from "./ViewProject";
// import CloseIcon from '@mui/icons-material/Close';
// import Create from '@mui/icons-material/AddBox';
// import SupplierIcon from '@mui/icons-material/GroupAdd';
// import InfoIcon from '@mui/icons-material/Info';
 
// const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
//   alternativeLabel: {
//     top: 22,
//   },
//   active: {
//     '& .MuiStepConnector-line': {
//       backgroundColor: '#784af4',
//     },
//   },
//   completed: {
//     '& .MuiStepConnector-line': {
//       backgroundColor: '#784af4',
//     },
//   },
//   line: {
//     height: 3,
//     border: 0,
//     backgroundColor: '#eaeaf0',
//     borderRadius: 1,
//   },
// }));
 
// const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
//   backgroundColor: '#ccc',
//   zIndex: 1,
//   color: '#fff',
//   width: 50,
//   height: 50,
//   display: 'flex',
//   borderRadius: '50%',
//   justifyContent: 'center',
//   alignItems: 'center',
//   ...(ownerState.active && {
//     backgroundColor: '#424752',
//   }),
//   ...(ownerState.completed && {
//     backgroundColor: '#66b266',
//   }),
// }));
 
// function ColorlibStepIcon(props) {
//   const { active, completed, className } = props;
 
//   const icons = {
//     1: <Create />,
//     2: <SupplierIcon />,
//     3: <InfoIcon />,
//   };
 
//   return (
//     <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
//       {icons[String(props.icon)]}
//     </ColorlibStepIconRoot>
//   );
// }
 
// const Workspace = () => {
//   const [open, setOpen] = useState(false);
//   const [activeStep, setActiveStep] = useState(0);
//   const [stepOneData, setStepOneData] = useState({ projectName: '', projectId: '' });
//   const [stepTwoData, setStepTwoData] = useState([]);
//   const [stepThreeData, setStepThreeData] = useState([]);
//   const [isFormModified, setIsFormModified] = useState(false);
//   const [error, setError] = useState('');
//   const [success, setSuccess] = useState(false);
//   const [showCloseDialog, setShowCloseDialog] = useState(false);
 
//   const steps = ['Create', 'Add Supplier', 'Fill Details'];
//   const baseURL = process.env.REACT_APP_API_BASE_URL;
//   const userRoles = JSON.parse(sessionStorage.getItem('userRoles')) || [];
//   const canCreateNew = userRoles.includes('Workspace_Edit');
 
//   const handleNext = async () => {
//     if (activeStep === 0) {
//       if (!stepOneData.projectName || !stepOneData.projectId) {
//         setError('Please fill in all required fields in Step 1.');
//         return;
//       }
//       try {
//         const response = await fetch(`${baseURL}check_project`, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({
//             projectId: stepOneData.projectId,
//             projectName: stepOneData.projectName,
//           }),
//         });
 
//         if (response.ok) {
//           setError('');
//           setActiveStep((prevActiveStep) => prevActiveStep + 1);
//         } else {
//           const errorData = await response.json();
//           setError(errorData.error || errorData.message || 'Error checking project uniqueness.');
//         }
//       } catch (error) {
//         console.error('Network or server error:', error);
//         setError('An error occurred while trying to connect to the API');
//       }
//       return;
//     } else if (activeStep === 1) {
//       if (stepTwoData.length === 0 || stepTwoData.some(supplier => !supplier.name || !supplier.id)) {
//         setError('Please add at least one supplier and fill in all required fields in Step 2.');
//         return;
//       }
//     }
 
//     setError('');
//     setActiveStep((prevActiveStep) => prevActiveStep + 1);
//   };
 
//   const handleBack = () => {
//     setActiveStep((prevActiveStep) => prevActiveStep - 1);
//   };
 
//   const handleReset = () => {
//     setActiveStep(0);
//     setStepOneData({ projectName: '', projectId: '' });
//     setStepTwoData([]);
//     setError('');
//     setIsFormModified(false);
//   };
 
//   const handleOpen = () => setOpen(true);
//   const handleClose = () => {
//     if (isFormModified) {
//       setShowCloseDialog(true);
//     } else {
//       setOpen(false);
//       handleReset();
//     }
//   };
 
//   const handleConfirmClose = () => {
//     setShowCloseDialog(false);
//     setOpen(false);
//     handleReset();
//   };
 
//   const handleCancelClose = () => {
//     setShowCloseDialog(false);
//   };
 
//   const handleFinish = async () => {
//     const suppliersWithDetails = stepTwoData.map((supplier, index) => ({
//       ...supplier,
//       details: {
//         ...stepThreeData[index],
//         moduleWattageData: stepThreeData[index]?.moduleWattageData.map((data, i) => ({
//           modulewattage: i + 1,
//           ...data,
//         })) || [],
//       },
//     }));
 
//     const projectData = {
//       projectCreate: { ...stepOneData },
//       addSupplier: suppliersWithDetails,
//     };
 
//     try {
//       const response = await fetch(`${baseURL}create_project`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(projectData),
//       });
 
//       if (response.ok) {
//         const data = await response.json();
//         setSuccess(true);
//         window.location.reload();
//       } else {
//         const errorData = await response.json();
//         console.error('Error from API:', errorData);
//         setError('Error: ' + errorData.error);
//       }
//     } catch (error) {
//       console.error('Network or server error:', error);
//       setError('An error occurred while trying to connect to the API');
//     } finally {
//       setOpen(false);
//       handleReset();
//     }
//   };
 
//   const handleStepOneDataChange = useCallback((data) => {
//     setStepOneData(data);
//     setIsFormModified(true);
//   }, []);
 
//   const handleStepTwoDataChange = (data) => {
//     setStepTwoData(data);
//     setIsFormModified(true);
//   };
 
//   const handleStepThreeDataChange = (data) => {
//     setStepThreeData(data);
//     setIsFormModified(true);
//   };
 
//   const renderStepContent = (step) => {
//     switch (step) {
//       case 0:
//         return <StepOne onStepOneDataChange={handleStepOneDataChange} formData={stepOneData} />;
//       case 1:
//         return <StepTwo supplierData={stepTwoData} onSupplierDataChange={handleStepTwoDataChange} />;
//       case 2:
//         return <StepThree supplierData={stepTwoData} onSupplierDataChange={handleStepThreeDataChange} />;
//       default:
//         return <div>Unknown step</div>;
//     }
//   };
 
//   return (
//     <div className="min-h bg-gray-100 p-6">
//       <div className="flex justify-end items-center mb-6">
//         { userRoles.includes('Workspace_Edit') && (
//           <Button variant="contained" color="primary" style={{ backgroundColor: '#424752' }} onClick={handleOpen}>
//             Create New
//           </Button>
//         )}
//       </div>
 
//       <div className="bg-white p-4 rounded shadow">
//         <h2 className="text-lg font-semibold mb-4">All Projects</h2>
//         <ViewProject />
//       </div>
 
//       <Modal
//         open={open}
//         onClose={handleClose}
//         BackdropProps={{ style: { pointerEvents: 'none' } }}
//       >
//         <Box
//           className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg shadow-lg w-full max-w-5xl"
//           sx={{
//             maxHeight: '90vh',
//             display: 'flex',
//             flexDirection: 'column',
//           }}
//         >
//           <div
//             className="relative flex justify-between items-center p-4 rounded-lg"
//             style={{ position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 2 }}
//           >
//             <h2 className="text-2xl font-bold text-center w-full">Create New Project</h2>
//             <IconButton onClick={handleClose} aria-label="close">
//               <CloseIcon />
//             </IconButton>
//           </div>
 
//           <div style={{ position: 'sticky', top: 64, zIndex: 1, backgroundColor: 'white', paddingBottom: '8px', boxShadow: '1px 1px 4px #888888' }}>
//             <Stepper
//               alternativeLabel
//               activeStep={activeStep}
//               connector={<ColorlibConnector />}
//             >
//               {steps.map((label, index) => (
//                 <Step key={index}>
//                   <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
//                 </Step>
//               ))}
//             </Stepper>
//           </div>
 
//           <div style={{ overflowY: 'auto', padding: '10px', flexGrow: 1 }}>
//             {error && <Alert severity="error">{error}</Alert>}
//             {activeStep === steps.length ? (
//               <div className="text-center">
//                 <p className="text-lg">All steps completed - you're finished</p>
//                 <Button onClick={handleFinish} variant="contained" color="primary" className="mt-6">
//                   Submit
//                 </Button>
//               </div>
//             ) : (
//               <div className="mt-6">
//                 {renderStepContent(activeStep)}
//                 <div className="flex justify-between mt-8">
//                   <Button disabled={activeStep === 0} onClick={handleBack}>
//                     Back
//                   </Button>
//                   <Button variant="contained" color="primary" style={{ backgroundColor: '#424752' }} onClick={handleNext}>
//                     {activeStep === steps.length - 1 ? 'Submit' : 'Next'}
//                   </Button>
//                 </div>
//               </div>
//             )}
//           </div>
//         </Box>
//       </Modal>
 
//       <Dialog open={showCloseDialog} onClose={handleCancelClose}>
//         <DialogTitle>Confirm Close</DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             You have unsaved changes. Are you sure you want to close the form? All changes will be lost.
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCancelClose} color="primary">
//             Cancel
//           </Button>
//           <Button onClick={handleConfirmClose} color="secondary">
//             Close Anyway
//           </Button>
//         </DialogActions>
//       </Dialog>
 
//       <Snackbar open={success} autoHideDuration={6000} onClose={() => setSuccess(false)}>
//         <Alert onClose={() => setSuccess(false)} severity="success" sx={{ width: '100%' }}>
//           Project created successfully!
//         </Alert>
//       </Snackbar>
//     </div>
//   );
// };
 
// export default Workspace;

// Workspace.js - FINAL VERSION (EVERYTHING WORKS PERFECTLY)
import React, { useState, useCallback } from 'react';
import { Modal, Box, Stepper, Step, StepLabel, Button, IconButton, StepConnector, Snackbar, Alert, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { styled } from '@mui/system';
import StepOne from './Steps/StepOne';
import StepTwo from './Steps/StepTwo';
import StepThree from './Steps/StepThree';
import ViewProject from "./ViewProject";
import CloseIcon from '@mui/icons-material/Close';
import Create from '@mui/icons-material/AddBox';
import SupplierIcon from '@mui/icons-material/GroupAdd';
import InfoIcon from '@mui/icons-material/Info';
import axios from 'axios';
import apiClient from '../../pages/keycloak/axiosInstance';

const defaultMaterials = [
  { name: "Cell", make: "", origin: "", description: "" },
  { name: "Glass(Front)", make: "", origin: "", description: "" },
  { name: "Glass(Back)", make: "", origin: "", description: "" },
  { name: "Encapsulant(Front)", make: "", origin: "", description: "" },
  { name: "Encapsulant(Back)", make: "", origin: "", description: "" },
  { name: "Flux", make: "", origin: "", description: "" },
  { name: "Interconnector", make: "", origin: "", description: "" },
  { name: "String Connector", make: "", origin: "", description: "" },
  { name: "Cell Fixing Tape", make: "", origin: "", description: "" },
  { name: "Frame", make: "", origin: "", description: "" },
  { name: "Junction Box", make: "", origin: "", description: "" },
  { name: "Adhesive(Sealant)", make: "", origin: "", description: "" },
  { name: "Potting Material", make: "", origin: "", description: "" },
  { name: "PV Connector", make: "", origin: "", description: "" },
];

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  alternativeLabel: { top: 22 },
  active: { '& .MuiStepConnector-line': { backgroundColor: '#784af4' } },
  completed: { '& .MuiStepConnector-line': { backgroundColor: '#784af4' } },
  line: { height: 3, border: 0, backgroundColor: '#eaeaf0', borderRadius: 1 },
}));

const ColorlibStepIconRoot = styled('div')(({ ownerState }) => ({
  backgroundColor: '#ccc', zIndex: 1, color: '#fff', width: 50, height: 50,
  display: 'flex', borderRadius: '50%', justifyContent: 'center', alignItems: 'center',
  ...(ownerState.active && { backgroundColor: '#424752' }),
  ...(ownerState.completed && { backgroundColor: '#66b266' }),
}));

function ColorlibStepIcon(props) {
  const { active, completed, icon } = props;
  const icons = { 1: <Create />, 2: <SupplierIcon />, 3: <InfoIcon /> };
  return <ColorlibStepIconRoot ownerState={{ active, completed }}>{icons[String(icon)]}</ColorlibStepIconRoot>;
}

const steps = ['Create', 'Add Supplier', 'Fill Details'];

const Workspace = () => {
  const [open, setOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [stepOneData, setStepOneData] = useState({ projectName: '', projectId: '', spvName: '', startDate: '', endDate: '' });
  const [stepTwoData, setStepTwoData] = useState([]); // suppliers with details attached
  const [isFormModified, setIsFormModified] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [showCloseDialog, setShowCloseDialog] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentEditProjectId, setCurrentEditProjectId] = useState(null);

  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const userRoles = JSON.parse(sessionStorage.getItem('userRoles') || '[]');
  const canCreateNew = userRoles.includes('Workspace_Edit');

  // OPEN MODAL (Create or Edit)
  const handleOpen = (projectId = null) => {
    if (projectId) {
      setIsEditMode(true);
      setCurrentEditProjectId(projectId);
      loadProjectForEdit(projectId);
    } else {
      setIsEditMode(false);
      handleReset();
    }
    setOpen(true);
  };

  // LOAD PROJECT FOR EDIT — THIS IS THE KEY FIX
  const loadProjectForEdit = async (projectId) => {
    try {
      const response = await apiClient.post(`get_project_detail`, { projectId });
      const { projectCreate, addSupplier = [] } = response.data;

      setStepOneData({
        projectName: projectCreate.projectName || '',
        projectId: projectCreate.projectId || '',
        spvName: projectCreate.spvName || '',
        startDate: projectCreate.startDate || '',
        endDate: projectCreate.endDate || '',
      });

      // Attach details directly to each supplier
      const suppliersWithDetails = addSupplier.map(s => ({
        id: s.id,
        name: s.name,
        shift: s.shift || 'DayNight',
        timeRanges: s.timeRanges || { day: { start: '', end: '' }, night: { start: '', end: '' } },
        details: s.details || {}
      }));

      setStepTwoData(suppliersWithDetails);
      setError('');
    } catch (err) {
      setError('Failed to load project');
      console.error(err);
    }
  };

  const handleNext = async () => {
    if (activeStep === 0 && !isEditMode) {
      if (!stepOneData.projectName || !stepOneData.projectId || !stepOneData.spvName) {
        setError('Please fill in all required fields in Step 1.');
        return;
      }
      try {
        await apiClient.post('check_project', {
          projectId: stepOneData.projectId,
          projectName: stepOneData.projectName,
        });
        setError('');
        setActiveStep(prev => prev + 1);
      } catch (err) {
        if (err.response && err.response.data) {
          setError(err.response.data.error || 'Project already exists');
        } else {
          setError('Network error');
        }
      }
      return;
    }

    if (activeStep === 1) {
      if (stepTwoData.length === 0 || stepTwoData.some(s => !s.name || !s.id)) {
        setError('Please add at least one supplier');
        return;
      }
    }

    setError('');
    setActiveStep(prev => prev + 1);
  };

  const handleBack = () => setActiveStep(prev => prev - 1);

  const handleReset = () => {
    setActiveStep(0);
    setStepOneData({ projectName: '', projectId: '', spvName: '', startDate: '', endDate: '' });
    setStepTwoData([]);
    setError('');
    setIsFormModified(false);
  };

  const handleClose = () => {
    if (isFormModified) {
      setShowCloseDialog(true);
    } else {
      setOpen(false);
      handleReset();
      setIsEditMode(false);
      setCurrentEditProjectId(null);
    }
  };

  const handleConfirmClose = () => {
    setShowCloseDialog(false);
    setOpen(false);
    handleReset();
    setIsEditMode(false);
    setCurrentEditProjectId(null);
  };

  const handleFinish = async () => {
    // Build payload EXACTLY like your reference
    const payload = {
      projectCreate: { ...stepOneData },
      addSupplier: stepTwoData.map(supplier => ({
        ...supplier,
        details: {
          ...(supplier.details || {}),
          moduleWattageData: (supplier.details?.moduleWattageData || []).map((w, i) => ({
            modulewattage: i + 1,  // ← Required by backend
            ...w,
            i1Location: w.i1Location || "",
            i2Location: w.i2Location || "",
            i3Location: w.i3Location || "",
          })),
          materials: Array.isArray(supplier.details?.materials) 
            ? supplier.details.materials 
            : defaultMaterials.map(m => ({ ...m })), 
        }
      }))
    };

    try {
      if (isEditMode) {
        await apiClient.put('edit_project', payload);
      } else {
        await apiClient.post('create_project', payload);
      }
      setSuccess(true);
      setTimeout(() => window.location.reload(), 1500);
    } catch (error) {
      console.error('Save error:', error);
      setError(error.response?.data?.error || 'Failed to save project');
    } finally {
      setOpen(false);
      handleReset();
      setIsEditMode(false);
    }
  };

  const handleStepOneDataChange = useCallback((data) => {
    setStepOneData(data);
    setIsFormModified(true);
  }, []);

  const handleStepTwoDataChange = (data) => {
    setStepTwoData(data);
    setIsFormModified(true);
  };

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return <StepOne onStepOneDataChange={handleStepOneDataChange} formData={stepOneData} isEditMode={isEditMode} />;
      case 1:
        return <StepTwo supplierData={stepTwoData} onSupplierDataChange={handleStepTwoDataChange} />;
      case 2:
        return <StepThree supplierData={stepTwoData} onSupplierDataChange={handleStepTwoDataChange} />;
      default:
        return <div>Unknown step</div>;
    }
  };

  return (
    <div className="min-h bg-gray-100 p-6">
      <div className="flex justify-end items-center mb-6">
        {canCreateNew && (
          <Button variant="contained" style={{ backgroundColor: '#424752' }} onClick={() => handleOpen()}>
            Create New
          </Button>
        )}
      </div>

      <div className="bg-white p-4 rounded shadow">
        <h2 className="text-lg font-semibold mb-4">All Projects</h2>
        <ViewProject onEdit={(projectId) => handleOpen(projectId)} />
      </div>

      {/* YOUR ORIGINAL MODAL — 100% UNCHANGED */}
      <Modal open={open} onClose={handleClose} BackdropProps={{ style: { pointerEvents: 'none' } }}>
        <Box className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg shadow-lg w-full max-w-5xl"
          sx={{ maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>
          <div className="relative flex justify-between items-center p-4 rounded-lg"
            style={{ position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 2 }}>
            <h2 className="text-2xl font-bold text-center w-full">
              {isEditMode ? 'Edit Project' : 'Create New Project'}
            </h2>
            <IconButton onClick={handleClose}><CloseIcon /></IconButton>
          </div>

          <div style={{ position: 'sticky', top: 64, zIndex: 1, backgroundColor: 'white', paddingBottom: '8px', boxShadow: '1px 1px 4px #888888' }}>
            <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
              {steps.map((label, index) => (
                <Step key={index}>
                  <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
          </div>

          <div style={{ overflowY: 'auto', padding: '10px', flexGrow: 1 }}>
            {error && <Alert severity="error">{error}</Alert>}
            {activeStep === steps.length ? (
              <div className="text-center">
                <p className="text-lg">All steps completed</p>
                <Button onClick={handleFinish} variant="contained" style={{ backgroundColor: '#424752' }} className="mt-6">
                  {isEditMode ? 'Update Project' : 'Submit'}
                </Button>
              </div>
            ) : (
              <div className="mt-6">
                {renderStepContent(activeStep)}
                <div className="flex justify-between mt-8">
                  <Button disabled={activeStep === 0} onClick={handleBack}>Back</Button>
                  <Button variant="contained" style={{ backgroundColor: '#424752' }} onClick={handleNext}>
                    {activeStep === steps.length - 1 ? 'Submit' : 'Next'}
                  </Button>
                </div>
              </div>
            )}
          </div>
        </Box>
      </Modal>

      <Dialog open={showCloseDialog} onClose={() => setShowCloseDialog(false)}>
        <DialogTitle>Confirm Close</DialogTitle>
        <DialogContent><DialogContentText>You have unsaved changes. Close anyway?</DialogContentText></DialogContent>
        <DialogActions>
          <Button onClick={() => setShowCloseDialog(false)}>Cancel</Button>
          <Button onClick={handleConfirmClose} color="secondary">Close Anyway</Button>
        </DialogActions>
      </Dialog>

      <Snackbar open={success} autoHideDuration={6000} onClose={() => setSuccess(false)}>
        <Alert onClose={() => setSuccess(false)} severity="success">
          Project {isEditMode ? 'updated' : 'created'} successfully!
        </Alert>
      </Snackbar>
    </div>
  );
};

export default Workspace;